(function ($) {
	var docReady = function () {
		initFancybox();
		initializeProductCarousel();
		productCardListener();
		addIconsToLists();
		setProductScrollHeight();
		appendFontAwesomeIcon($('.preowned__search-form .ginput_container_select'));
		removeSvgAttrs();
		productCardListener();
		setProductScrollHeight();
		appendFontAwesomeIcon($('.preowned__search-form .ginput_container_select'));
		hideEmptySections();
		sortByOnSubmit();
		removeSvgAttrs();
	};

	$(document).ready(function () {
		docReady();
	});

	function initFancybox() {
		console.log('init fancybox');

		Fancybox.bind('[data-fancybox]');

		console.log(Fancybox);
	}

	function setGalleryImageHeight($card) {
		var $parentContainer = $card.closest('.product-single__content-container');
		if ($parentContainer.length) {
			var $content = $parentContainer.find('.product-single__content').first();
			var $gallery = $parentContainer.find('.product-single__gallery').first();
			var contentHeight = $content.innerHeight();
			$gallery.height(contentHeight);
		}
	}

	/**
	 * click listener for slideToggle collapsible product cards
	 */
	function productCardListener() {
		var $cards = $('.product-card');
		if ($cards.length) {
			$cards.each(function (index, element) {
				// on load
				$(element)
					.find('.product-card__content')
					.slideUp(function () {
						toggleAccordionHeader($(this));
						setGalleryImageHeight($(this));
					});

				// on click
				$(element)
					.find('.product-card__header')
					.click(function () {
						$(this)
							.siblings()
							.first()
							.slideToggle(function () {
								toggleAccordionHeader($(this));
								setGalleryImageHeight($(this));
							});
					});
			});
		}
	}

	/**
	 * class toggle for product card listener:
	 *     toggles +/- icon in header
	 */
	function toggleAccordionHeader($element) {
		$element
			.parent()
			.find('.product-card__header')
			.toggleClass('product-card__header--active');
	}

	/**
	 * adds angle-down icon to dropdowns for gravity forms
	 *
	 * @param  {$element} element
	 */
	function appendFontAwesomeIcon(element) {
		element.addClass('fa fa-angle-down');
	}

	/**
	 * sets overall scroll height for preowned product card
	 *     since the section is set to overflow/scroll, this sets the height
	 *     such that the main content can be seen on load.
	 */
	function setProductScrollHeight() {
		var mediaQuery = window.matchMedia('(min-width: 1024px)');

		if (mediaQuery.matches) {
			setTimeout(function () {
				var $contactBar = $('.product-detail__contact-bar--preowned').first();
				var $container = $('.preowned-detail__content-container').first();
				var containerPadding = parseInt($container.css('paddingBottom'));
				var contactBarHeight = $contactBar.innerHeight();
				$container.css('paddingBottom', contactBarHeight);
			}, 250);
		}
	}

	/**
	 * simply removes static width/height attrs from svg
	 */
	function removeSvgAttrs() {
		$wrappers = $('.new-trucks-trailers__item-star-wrap');
		if ($wrappers?.length) {
			$wrappers.each(function (index, element) {
				var $star = $(element).find('svg');
				$star.removeAttr('width', '');
				$star.removeAttr('height', '');
			});
		}
	}

	/**
	 * product carousel, swiper initialization
	 */
	function initializeProductCarousel() {
		console.log('initializeProductCarousel');

		//* Component gallery
		var galleryThumbs = new Swiper('.gallery-thumbs', {
			spaceBetween: 10,
			slidesPerView: 9,
			reverseDirection: true,
			// loop: true,
			// freeMode: true,
			// watchSlidesVisibility: true,
			// watchSlidesProgress: true,
			breakpoints: {
				320: {
					slidesPerView: 3,
				},
				640: {
					slidesPerView: 6,
				},
				1024: {
					slidesPerView: 9,
				},
			},
		});
		var galleryCaptions = new Swiper('.gallery-captions', {
			spaceBetween: 10,
			loop: true,
			// slidesPerView: 1,
			freeMode: false,
			allowTouchMove: false,
			allowSlidePrev: false,
			allowSlideNext: false,
		});
		var gallery = new Swiper('.gallery-full', {
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			thumbs: {
				swiper: galleryThumbs,
			},
			controller: {
				control: [galleryCaptions],
			},
		});

		var galleryFull = new Swiper('.gallery-full', {
			// spaceBetween: 10,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			thumbs: {
				swiper: galleryThumbs,
			},
		});

		var galleryFullNoThumbs = new Swiper('.gallery-full-no-thumbs', {
			// spaceBetween: 10,
			loop: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			controller: {
				control: [galleryFullNoThumbs, galleryCaptions],
			},
		});

		galleryFull.on('slideChangeTransitionEnd', function () {
			console.log('slideChangeTransitionEnd', this);
			galleryThumbs.slideToLoop(this.realIndex);
		});
	}

	/**
	 * prepends font-awesome check-circle icons to stylized list divs
	 */
	function addIconsToLists() {
		$('.entry-content--stylized-list').each(function (index, element) {
			var $list = $(element).find('ul li');
			$list.each(function (index, element) {
				$(element).prepend(
					'<span class="fa-li"><i class="fas fa-check-circle"></i></span>'
				);
			});
		});
	}

	function hideEmptySections() {
		var $sections = $('.new-detail__section');
		$sections.each(function (index, section) {
			var $section = $(section);
			var $children = $section.children();
			var length = $children.length;
			if (length === 0) {
				$section.remove();
			}
		});
	}

	function getFormUrl(query) {
		return '//' + window.location.host + window.location.pathname + '?' + query;
	}

	function sortByOnSubmit() {
		var $menu = $('#sort-posts');
		$menu.on('change', function () {
			var urlParams = new URLSearchParams(window.location.search);
			if (urlParams.has('sort-posts')) {
				urlParams.set('sort-posts', $(this).val());
			} else {
				urlParams.append('sort-posts', $(this).val());
			}

			var formUrl = getFormUrl(urlParams.toString());

			window.location.href = formUrl;

			// console.log(formUrl);
		});
	}
})(jQuery);
